import React, { useEffect, useRef } from 'react';

interface SettingsWrapperProps {
    title?: string;
    scrollKey?: string;
    children: React.ReactNode;
}

const SettingsWrapper: React.FC<SettingsWrapperProps> = ({ title, scrollKey, children }) => {
    const scrollContainerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        scrollContainerRef.current?.scrollTo({ top: 0 });
    }, [scrollKey]);

    return (
        <div className="relative flex min-w-0 flex-1 flex-col overflow-hidden bg-[#F4F5F8] h-full w-full">
            <div
                ref={scrollContainerRef}
                className="flex-1 overflow-y-scroll [scrollbar-gutter:stable] custom-scrollbar"
            >
                <div className="max-w-[1120px] mx-auto px-10 py-7 pb-14 pr-20">
                    {title && (
                        <div className="mb-8">
                            <h2 className="text-[20px] font-medium tracking-[-0.01em] text-[#1A162F]">{title}</h2>
                        </div>
                    )}
                    {children}
                </div>
            </div>
        </div>
    );
};

export default SettingsWrapper;
